import React from 'react';
import { string } from 'prop-types';
import { TileHead } from '../TileHead';

const OffshoreSthUnavailable = ({ stateName }) => {
  return (
    <div className="fulfillment-tile">
      <TileHead title="Delivery" />
      <span className="fulfillment__primary_color fulfillment-msg">
        Unavailable in {stateName}
      </span>
    </div>
  );
};

OffshoreSthUnavailable.propTypes = {
  stateName: string
};

OffshoreSthUnavailable.defaultProps = {
  stateName: '',
};

export { OffshoreSthUnavailable };
